import { ProgressSpinner } from 'primereact/progressspinner';
import { useEffect } from 'react';
import styles from './Loader.module.scss';

export const Loader = () => {
	useEffect(() => {
		document.body.style.pointerEvents = 'none';
		document.body.style.overflow = 'hidden';
		document.body.style.backgroundColor = 'rgba(128, 128, 128, 0.5)';

		const handleBeforeUnload = (e: BeforeUnloadEvent) => {
			e.preventDefault();
			e.returnValue = '';
		};

		window.addEventListener('beforeunload', handleBeforeUnload);

		return () => {
			window.removeEventListener('beforeunload', handleBeforeUnload);
			document.body.style.pointerEvents = 'auto';
			document.body.style.overflow = 'auto';
			document.body.style.backgroundColor = 'white';
		};
	}, []);

	return (
		<div className={styles.loader}>
			<ProgressSpinner />
		</div>
	);
};
